import { Outlet } from 'react-router-dom';
import { DashboardLayoutSidebar } from './DashboardLayoutSidebar';
import { SidebarInset, SidebarProvider } from '@design-system/Sidebar';
import { DashboardLayoutBottomNavBar } from './DashboardLayoutBottomNavBar';
import { useBootup } from '@hooks/useBootup';
import { ErrorLoadingPage } from '@screens/ErrorHandling/ErrorLoadingPage';
import { Loader } from '@design-system/Loader';

export const DashboardLayout = () => {
  const { isError, isLoading } = useBootup();

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <ErrorLoadingPage errorType='logout' hideNavBar />;
  }

  return (
    <SidebarProvider>
      <DashboardLayoutSidebar />
      <SidebarInset className="bg-background-secondary">
        <div className="flex flex-1 flex-col max-md:mb-16">
          <Outlet />
          <DashboardLayoutBottomNavBar />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
};
